import React, { useState, useRef, useEffect } from 'react';
import '../../../VendorStyles/VendorTopMenuBar.css';
import vendorDefaultBannerImage from '../../../assets/vendortopbackground.png';
import Notification from '../../User/Notification/Notification';
import axiosVendorInstance from '../../../axiosVendorInstance';
import { Skeleton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
// import VendorNotificationIcon from '../../../assets/svg/vendorNotificationIcon';
import { useNotifications } from '../../User/Notification/NotificationContext';
import { useCart } from '../../../CartProvider';
import ProfileAvatar from '../../User/ProfileAvatar/ProfileAvatar';
import NotificationIcon from '../../../assets/svg/notificationIcon';
import locationIcon from '../../../assets/locationImg.svg';
import starPic from '../../../assets/StarWhite.svg';
import { useTranslation } from 'react-i18next';

function VendorTopMenuBar() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const overlayRef = useRef(null);
    const [NotificationOverlay, setNotificationOverlay] = useState(false);
    const [vendorName, setVendorName] = useState();
    const [restaurantImagePreview, setRestaurantImagePreview] = useState();
    const [bannerImagePreview, setBannerImagePreview] = useState();
    const [restaurantAddress, setRestaurantAddress] = useState();
    const [restaurantRating, setRestaurantRating] = useState();
    const [restaurantUserRatingCount, setRestaurantUserRatingCount] = useState();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
    const { notificationCountvalue } = useNotifications();
    const { vendorProfileImage, vendorUserData, setCurrentVendorId } = useCart();
    const { t } = useTranslation();

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 2000);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 601);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleProfile = () => {
        navigate('/vendor-settings');
    };

    const fetchVendor = async () => {
        try {
            setIsLoading(true);
            const response = await axiosVendorInstance.get('/vendors/account');
            const vendor = response?.data?.getVendorInfo[0];
            setCurrentVendorId(vendor?.ID);
            setVendorName(vendor?.Name);
            setRestaurantImagePreview(vendor?.Avatar_key);
            setBannerImagePreview(vendor?.Banner_Image);
            const cleanedAddress = vendor?.Address?.trim().replace(/,+\s*$/, '');

            const fullAddress = `${cleanedAddress}, ${vendor?.city}, ${vendor?.state}, ${vendor?.country} - ${vendor?.pincode}`;
            setRestaurantAddress(fullAddress);

            setRestaurantRating(vendor?.menuItem_averageRating);
            setRestaurantUserRatingCount(
                vendor?.menuItem_reviewUserCount
            );
        } catch(error) {
            console.error('Error fetching vendor:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchVendor();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (overlayRef.current && !overlayRef.current.contains(event.target)) {
                setNotificationOverlay(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const closenotificationoverlay = () => {
        setNotificationOverlay(false);
    };

    const restaurantImageURL = restaurantImagePreview?.trim()
        ? restaurantImagePreview
        : null;
    const restaurantName = (vendorName || '').toUpperCase();

    return (
        <>
            <div className='vendor-topbar-container'>
                <div className='desktop-vendor-background'>
                    <img
                        src={bannerImagePreview || vendorDefaultBannerImage}
                        alt='Banner'
                    />
                </div>
                <div className='vendor-banner-overlay'></div>
                <div className='vendor-restaurant-logo-container'>
                    {isLoading && !isMobile ? (
                        <Skeleton variant='square' height={130} width='100px' />
                    ) : restaurantImageURL ? (
                        <img
                            className='vendor-restaurant-logo'
                            src={restaurantImagePreview}
                            alt='profile'
                        />
                    ) : (
                        <span className='fallback-restaurant-name'>{restaurantName}</span>
                    )}
                </div>

                {!isLoading && (
                    <div className='vendor-turn-on-location-container'>
                        {isLoading ? (
                            <Skeleton variant='text' width={200} height={50} />
                        ) : (
                            <h6 className='vendor-name'>{vendorName}</h6>
                        )}

                        <div className='restaurant-address-container'>
                            <img
                                src={locationIcon}
                                alt='location'
                                className='location-icon-restaurant'
                            />
                            <p className='resturant-address1'>{restaurantAddress}</p>
                        </div>

                        <div className='res-star-rating1'>
                            <div className='img-rating-restaurant1'>
                                <p className='rating-order1'>
                                    {isNaN(Number(restaurantRating))
                                        ? '0.0'
                                        : Number(restaurantRating || 0.0)?.toFixed(1)}
                                </p>
                                <img 
                                    className='star-img-order1' 
                                    src={starPic} 
                                    alt='star' 
                                    style={{marginBottom:'4px'}}
                                />
                            </div>
                            <div className='customer-count-rating1'>
                                <p className='rating-count-restaurant11'>
                                    {restaurantUserRatingCount || 0}
                                </p>
                                <p className='rating-text11'>
                                    {t('restaurantpage.ratings-text')}
                                </p>
                            </div>
                        </div>
                    </div>
                )}
                <div className='vendor-profile-and-notification'>
                    {isLoading ? (
                        <Skeleton
                            className='vendor-profile-icon'
                            variant='circle'
                            height={50}
                            width={50}
                        />
                    ) : (
                        ((vendorUserData?.first_name && vendorUserData?.last_name) ||
              vendorUserData?.first_name ||
              vendorUserData?.last_name ||
              vendorProfileImage) && (
                            <ProfileAvatar
                                className={'profile-icon'}
                                firstName={vendorUserData?.first_name || ''}
                                lastName={vendorUserData?.last_name || ''}
                                profilePic={vendorProfileImage}
                                height={30}
                                width={30}
                                fontSize={16}
                                onClick={() => handleProfile()}
                            />
                        )
                    )}

                    <div className='vendor-topbar-top-icons'>
                        {isLoading ? (
                            <Skeleton
                                className='vendor-notification-icon'
                                variant='rounded'
                                height={50}
                                width={50}
                            />
                        ) : (
                            <NotificationIcon
                                className='notification-icon'
                                notificationcount={notificationCountvalue}
                                onClick={() => setNotificationOverlay(!NotificationOverlay)}
                            />
                        )}
                    </div>
                    {NotificationOverlay && (
                        <>
                            <div className='vendor-notification-overlay' ref={overlayRef}>
                                <Notification closeOverlay={closenotificationoverlay} />
                            </div>
                        </>
                    )}
                </div>
            </div>

            {isMobile && (
                <div className='vendor-topbar-container'>
                    {isLoading ? (
                        <Skeleton variant='square' height={70} width='70px' />
                    ) : restaurantImageURL ? (
                        <img
                            className='vendor-restaurant-logo'
                            src={restaurantImagePreview}
                            alt='profile'
                        />
                    ) : (
                        <span className='fallback-restaurant-name'>{restaurantName}</span>
                    )}
                    <NotificationIcon
                        className='notification-icon'
                        notificationcount={notificationCountvalue}
                        onClick={() => setNotificationOverlay(!NotificationOverlay)}
                    />
                </div>
            )}
        </>
    );
}

export default VendorTopMenuBar;